// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__QwD+f","footer__dark":"Footer_footer__dark__ERl8B"};